import React, { useEffect } from "react";
import { CSSProperties, useState } from "react";
// import "rsuite/dist/rsuite.min.css";
import {
  BrowserRouter,
  createBrowserRouter,
  useParams,
  useNavigation,
} from "react-router-dom";
import WallOf_Img from "../../Assets/Icons/bywallof_logo.jpg";

import CIcon from "@coreui/icons-react";
import {
  cilCloudDownload,
  cilLayers,
  cilPuzzle,
  cilSpeedometer,
} from "@coreui/icons";
import ControllersSub from "./Sub/controllers";
import PlayersSub from "./Sub/players";
import { portalStore } from "../../Stores/portal";
import { observer } from "mobx-react";
import { BottomStatusBar, TopNaviation } from "./NavigationBar";
import { SmartScreen } from "../Main/smartScreen";
import { Container } from "react-bootstrap";
import { authStore } from "../../App";
// import { Nav, Sidenav } from "rsuite";
const PortalScreen: React.FC = () => {
  const [height, setHeight] = useState(window.innerHeight);
  const [forceNewStore, setForceNewStore] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerWidth);
    };

    // Add event listener when the component mounts
    window.addEventListener("resize", handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [authStore.stores]);
  return (
    <div>
      <div
        style={{
          width: "100vw",
          padding: 0,
          margin: 0,
          overflow: "hidden",
          height: height,
          display: "flex",
          flexFlow: "column",
        }}
      >
        <BrowserRouter>
          <TopNaviation />
          <Container
            fluid
            style={{
              height: portalStore.portalHeight,
              overflowY: "hidden",
              marginBottom: portalStore.bottomStatusBarHeight,
            }}
          >
            <SmartScreen />
          </Container>
          <BottomStatusBar />
        </BrowserRouter>
      </div>
    </div>
  );
};

const MainContainer_: React.FC = () => {
  const param = useParams();

  switch (portalStore.activeScreen) {
    case "Controllers":
      return <>Controllers</>;

    case "Dashboard":
      return <>Main Dashboard</>;

    case "Players":
      return <>Players</>;
    default:
      return <>This is dashbaord</>;
  }
};

const MainContainer = observer(MainContainer_);

const Styling = {} as CSSProperties;

export default PortalScreen;
